export const pid = () => {
  return {
    regex: /^\d{13}$/,
    condition: /^\d{0,13}$/,
  };
};

export const postCode = () => {
  return {
    regex: /^\d{5}$/,
    condition: /^\d{0,5}$/,
  };
};

export const laserId = () => {
  return {
    regex: /^[a-zA-Z]{2}\d{10}$/,
    condition: /^[a-zA-Z0-9]{0,12}$/,
  };
};

export const phoneNumber = () => {
  return {
    regex: /^[0]{1}[689]{1}\d{8}$/,
    condition: /^\d{0,10}$/,
  };
};

export const password = () => {
  return {
    regex:
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[1-9])(?=.*)[A-Za-z0-9!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{8,}$/,
    condition: /^[0-9a-zA-Z!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{0,}$/,
  };
};

const conditions = {
  length: /^.{8,}$/,
  lowercase: /[a-z]/,
  uppercase: /[A-Z]/,
  number: /[1-9]/,
  specialChar: /[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/,
};

export const validatePassword = (password) => {
  // let missingConditions = [];

  if (
    !conditions.length.test(password) ||
    !conditions.lowercase.test(password) ||
    !conditions.uppercase.test(password) ||
    !conditions.number.test(password)
  ) {
    // missingConditions.push("length");
    return false;
  } else {
    return true;
  }

  // return missingConditions;
};

export const validateLengthPassword = (password) => {
  if (!conditions.length.test(password)) {
    return `text-[#F05252]`;
  } else {
    return `text-[#0E9F6E]`;
  }
};
//
export const iconLengthPassword = (password) => {
  if (!conditions.length.test(password)) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="icon icon-tabler icons-tabler-outline icon-tabler-x"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M18 6l-12 12" />
        <path d="M6 6l12 12" />
      </svg>
    );
  } else {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="icon icon-tabler icons-tabler-outline icon-tabler-check"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M5 12l5 5l10 -10" />
      </svg>
    );
  }
};

export const validateNumberPassword = (password) => {
  if (!conditions.number.test(password)) {
    return `text-[#F05252]`;
  } else {
    return `text-[#0E9F6E]`;
  }
};

export const iconNumberPassword = (password) => {
  if (!conditions.number.test(password)) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="icon icon-tabler icons-tabler-outline icon-tabler-x"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M18 6l-12 12" />
        <path d="M6 6l12 12" />
      </svg>
    );
  } else {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="icon icon-tabler icons-tabler-outline icon-tabler-check"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M5 12l5 5l10 -10" />
      </svg>
    );
  }
};

export const validateLowercasePassword = (password) => {
  if (!conditions.lowercase.test(password)) {
    return `text-[#F05252]`;
  } else {
    return `text-[#0E9F6E]`;
  }
};

export const iconLowercasePassword = (password) => {
  if (!conditions.lowercase.test(password)) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="icon icon-tabler icons-tabler-outline icon-tabler-x"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M18 6l-12 12" />
        <path d="M6 6l12 12" />
      </svg>
    );
  } else {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="icon icon-tabler icons-tabler-outline icon-tabler-check"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M5 12l5 5l10 -10" />
      </svg>
    );
  }
};

export const validateUppercasePassword = (password) => {
  if (!conditions.uppercase.test(password)) {
    return `text-[#F05252]`;
  } else {
    return `text-[#0E9F6E]`;
  }
};

export const iconUppercasePassword = (password) => {
  if (!conditions.uppercase.test(password)) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="icon icon-tabler icons-tabler-outline icon-tabler-x"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M18 6l-12 12" />
        <path d="M6 6l12 12" />
      </svg>
    );
  } else {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="icon icon-tabler icons-tabler-outline icon-tabler-check"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M5 12l5 5l10 -10" />
      </svg>
    );
  }
};

export const validateSpecialCharPassword = (password) => {
  if (!conditions.specialChar.test(password)) {
    return `text-[#F05252]`;
  } else {
    return `text-[#0E9F6E]`;
  }
};

export const iconSpecialCharPassword = (password) => {
  if (!conditions.specialChar.test(password)) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="icon icon-tabler icons-tabler-outline icon-tabler-x"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M18 6l-12 12" />
        <path d="M6 6l12 12" />
      </svg>
    );
  } else {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="icon icon-tabler icons-tabler-outline icon-tabler-check"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M5 12l5 5l10 -10" />
      </svg>
    );
  }
};

export const number = () => {
  return {
    regex: /^[0-9]*$/,
    condition: /^[0-9]*$/,
  };
};

export const otp = () => {
  return {
    regex: /^[0-9]*$/,
    condition: /^\d{0,6}$/,
  };
};

export const FormatNumber = (number) => {
  if(number){
    const formattedNumber = number.toLocaleString();
    return formattedNumber;
  }

};
